var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mail-out"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.64631 7.15461C3.83778 6.86741 4.22582 6.7898 4.51303 6.98127L7.91634 9.25015L11.3197 6.98127C11.6069 6.7898 11.9949 6.86741 12.1864 7.15461C12.3778 7.44182 12.3002 7.82986 12.013 8.02133L8.26303 10.5213C8.05309 10.6613 7.77959 10.6613 7.56965 10.5213L3.81965 8.02133C3.53245 7.82986 3.45484 7.44182 3.64631 7.15461Z",
    fill: "#656579"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.49967 4.79297C1.92438 4.79297 1.45801 5.25934 1.45801 5.83464V14.168C1.45801 14.7433 1.92438 15.2096 2.49967 15.2096H14.1663C14.5115 15.2096 14.7913 15.4895 14.7913 15.8346C14.7913 16.1798 14.5115 16.4596 14.1663 16.4596H2.49967C1.23402 16.4596 0.208008 15.4336 0.208008 14.168V5.83464C0.208008 4.56898 1.23402 3.54297 2.49967 3.54297H13.333C14.5987 3.54297 15.6247 4.56898 15.6247 5.83464V7.5013C15.6247 7.84648 15.3449 8.1263 14.9997 8.1263C14.6545 8.1263 14.3747 7.84648 14.3747 7.5013V5.83464C14.3747 5.25934 13.9083 4.79297 13.333 4.79297H2.49967Z",
    fill: "#656579"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6083 12.1099C19.8524 11.8658 19.8524 11.4701 19.6083 11.226L17.1083 8.72603C16.8642 8.48195 16.4685 8.48195 16.2244 8.72603C15.9803 8.97011 15.9803 9.36583 16.2244 9.60991L17.6575 11.043H14.1663C13.8212 11.043 13.5413 11.3228 13.5413 11.668C13.5413 12.0131 13.8212 12.293 14.1663 12.293H17.6575L16.2244 13.726C15.9803 13.9701 15.9803 14.3658 16.2244 14.6099C16.4685 14.854 16.8642 14.854 17.1083 14.6099L19.6083 12.1099Z",
    fill: "#656579"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailout);
export default __webpack_public_path__ + "static/media/mailout.242df732fd5a6a2f9f5a65c51e7ce0b0.svg";
export { ForwardRef as ReactComponent };